import React from 'react';
import PropTypes from 'prop-types';

const PLPSEO = (props) => {
  const { opts, channel, children } = props;
  const {
    options,
    id,
    RowHeadtext,
    Paragraphtext
  } = opts;
  return (
    <div>
      <div className="rowHeaderDiv">
        <h2 className="row-header align-l plp-header">
          <div className="row-header__title">
            {RowHeadtext
            && (
              <span className="row-header__text">
                {RowHeadtext}
              </span>
            )}
            {options.hasLink
            && (
              <a
                href={options.url}
                className="row-header__link"
                target={options.targetBlank ? '_blank' : ''}
              >
                {options.linkText}
              </a>
            )}
          </div>
        </h2>
      </div>
      {options.addParagraph
      && (
        <div className="paragraphDiv">
          {options.url ? (
            <p className="content u__regular u__text--dark">
              <a href={options.url}>
                {Paragraphtext}
              </a>
            </p>
          ) : (
            <div dangerouslySetInnerHTML={{ __html: Paragraphtext }} />
          )}
        </div>
      )}
      {options.addList
      && (
        <div className="plpSeo__list">
          {children}
        </div>
      )}
    </div>
  );
};

PLPSEO.propTypes = {
  opts: PropTypes.shape({
    id: PropTypes.string,
    RowHeadtext: PropTypes.string,
    Paragraphtext: PropTypes.string,
    options: PropTypes.shape({
      name: PropTypes.string,
      targetBlank: PropTypes.bool,
      addParagraph: PropTypes.bool,
      listType: PropTypes.shape({
        isNone: PropTypes.bool,
        isUnordered: PropTypes.bool,
        isOrdered: PropTypes.bool
      }),
      addList: PropTypes.bool,
      readmore: PropTypes.string,
      hasLink: PropTypes.bool,
      linkText: PropTypes.string,
      url: PropTypes.string
    }).isRequired
  }),
  channel: PropTypes.string,
  children: PropTypes.instanceOf(Array)
};

PLPSEO.defaultProps = {
  channel: 'desktop',
  opts: {
    id: '',
    RowHeadtext: '',
    Paragraphtext: ''
  },
  children: []
};

export default PLPSEO;
